export default __webpack_public_path__ + "static/media/brand-visual.c2d72b43.png";